import { render } from "./list.vue?vue&type=template&id=b5b21480&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"

import "./list.vue?vue&type=style&index=0&id=b5b21480&lang=scss&scoped=true"

import exportComponent from "/root/workspace/zyy-iot_zyy-iot-web-v2_Ejzw/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5b21480"]])

export default __exports__